import { render, staticRenderFns } from "./Umfrage.vue?vue&type=template&id=8c5c087a&scoped=true"
import script from "./Umfrage.vue?vue&type=script&lang=js"
export * from "./Umfrage.vue?vue&type=script&lang=js"
import style0 from "./Umfrage.vue?vue&type=style&index=0&id=8c5c087a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5c087a",
  null
  
)

export default component.exports